import React from 'react';

import { useAppDispatch } from 'redux/store';
import { getCourseWelcomeEmail } from 'redux/actions/course-communications';
import { CommunicationType } from 'redux/schemas/models/course-communication';
import CommunicationModal from 'course_communications/components/communication-modal/communication-modal';
import {
  reducer,
  TriggerType,
  initialState,
  CommunicationAction,
  CommunicationDispatch,
} from 'course_communications/contexts/communication-context';

type Props = {
  catalogId: string,
  children: (openModal: Function) => void,
};

const WelcomeEmailModalWrapper = (props: Props) => {
  const {
    children,
    catalogId,
  } = props;

  const reduxDispatch = useAppDispatch();
  const [State, dispatch] = React.useReducer(reducer, initialState);

  React.useEffect(() => {
    reduxDispatch(getCourseWelcomeEmail({ catalogId }));
  }, [catalogId, reduxDispatch]);

  const openModal = (isCreate: boolean) => {
    dispatch({
      type: CommunicationAction.SHOW_MODAL,
      communicationType: CommunicationType.COURSE_WELCOME_EMAIL,
      triggerType: isCreate ? TriggerType.CREATE : TriggerType.EDIT,
    } as any);
  };

  return (
    <CommunicationDispatch.Provider value={{ State, dispatch }}>
      {children(openModal)}
      <CommunicationModal catalogId={catalogId} />
    </CommunicationDispatch.Provider>
  );
};

export default WelcomeEmailModalWrapper;
